export var TimeUnit;
(function (TimeUnit) {
    TimeUnit["Milliseconds"] = "MILLISECONDS";
    TimeUnit["Seconds"] = "SECONDS";
    TimeUnit["Minutes"] = "MINUTES";
    TimeUnit["Hours"] = "HOURS";
    TimeUnit["Days"] = "DAYS";
})(TimeUnit || (TimeUnit = {}));
export var TimeConstants;
(function (TimeConstants) {
    TimeConstants[TimeConstants["SecondsInHour"] = 3600] = "SecondsInHour";
    TimeConstants[TimeConstants["SecondsInDay"] = 86400] = "SecondsInDay";
    TimeConstants[TimeConstants["SecondsInWeek"] = 604800] = "SecondsInWeek";
    TimeConstants[TimeConstants["SecondsInYear"] = 31536000] = "SecondsInYear";
    TimeConstants[TimeConstants["MillisecondsInMinute"] = 60000] = "MillisecondsInMinute";
    TimeConstants[TimeConstants["MillisecondsInAnHour"] = 3600000] = "MillisecondsInAnHour";
})(TimeConstants || (TimeConstants = {}));
//# sourceMappingURL=time-unit.enum.js.map